import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert, Spinner } from 'react-bootstrap';
import FormBusca from './form_busca';
import DiarioService from '../../../services/diario'
import Diario from './diario';
import LeitorPDF from './leitorPDF';
import Botoes from './botoes';

const ListarDiarios = () => {


    const [diarios, setDiarios] = useState([]);
    const [vazio, setVazio] = useState(false);
    const [aguardando, setAguardando] = useState(true);
    const [pdfSelecionado, setPdfSelecionado] = useState(null);
    const [ano, setAno] = useState("");
    const pathName = window.location.pathname;

    const getTipo = (path) => {
        switch (path) {
            case '/transparencia/diario/expomacuco/2025':
                setAno("2025");
                return { ano: "2025", service: DiarioService.buscarExpo };
            case '/transparencia/diario/expomacuco/2024':
                setAno("2024");
                return { ano: "2024", service: DiarioService.buscarExpo };
            case '/transparencia/diario/expomacuco/2023':
                setAno("2023");
                return { ano: "2023", service: DiarioService.buscarExpo };
            case '/transparencia/diario/expomacuco/anteriores':
                return { ano: "2022", service: DiarioService.buscarExpo };
            default:
                return { ano: null, service: null };
        }
    };


    async function fetchDiariosIn() {
        const { ano, service } = getTipo(pathName);

        if (!service) {
            setDiarios([]);
            setVazio(true);
            return;
        }
        const response = await service(ano ? { ano: ano } : {});
        if (response.data.length >= 1) {
            setDiarios(response.data)
            setVazio(false)
            setAguardando(false)
        } else {
            setDiarios([])
            setVazio(true)
        }
    }

    const handleLerDiario = (url) => {
        setPdfSelecionado(url);
    };

    const handleFecharLeitor = () => {
        setPdfSelecionado(null);
    };



    useEffect(() => {
        fetchDiariosIn();
    }, [window.location.pathname]);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setDiarios={setDiarios}
                    setVazio={setVazio}
                    setAguardando={setAguardando}
                    fetchDiariosIn={fetchDiariosIn}
                    diarios={diarios}
                />
            </Fragment>
            {aguardando ?
                <Fragment>
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Carregando dados...</span>
                    </Spinner>
                    <Alert variant='warning'>Estamos fazendo uma busca usando palavra-chave, ela é demorada. Podendo levar de 1 a 5 minutos para ser executada. O motivo é: o sistema está lendo todos os PDF's de todos os diários para achar sua busca.
                        Para obter um resultado mais rápido, utilize também os campos de mês e ano.</Alert>
                </Fragment>
                :
                <Fragment>
                    {vazio ? <Fragment>
                        <Botoes />
                    </Fragment> :
                        <Fragment>
                            <Row xs={1}>
                                {diarios.map((diario, index) =>
                                    <Diario
                                        diario={diario}
                                        key={index}
                                        onLerDiario={handleLerDiario}
                                    />
                                )}
                                {pdfSelecionado && (
                                    <LeitorPDF file={pdfSelecionado} onClose={handleFecharLeitor} />
                                )}
                            </Row>
                        </Fragment>}
                </Fragment>}
        </Fragment>

    )
}

export default ListarDiarios;